import React from 'react';
import { createGettextApi } from './gettext-api';
import { resolveLocaleDirection } from './resolve-locale-direction';
export const I18nContext = /*#__PURE__*/React.createContext(null);
/**
 * Wrap your app in this provider to allow components to access gettext APIs via the useI18n hook
 */
export const I18nProvider = _ref => {
  let {
    lang,
    locale,
    translations,
    children
  } = _ref;
  const i18nApi = React.useMemo(() => {
    const api = createGettextApi(translations, lang);
    api.lang = lang;
    api.locale = locale;
    api.direction = resolveLocaleDirection(locale);
    return api;
  }, [lang, locale, translations]);
  return /*#__PURE__*/React.createElement(I18nContext.Provider, {
    value: i18nApi
  }, children);
};
//# sourceMappingURL=i18n-context.js.map